"use strict";

var moduleName = "form-validation";

module.exports = function () {
	$("form").each(function () {
		if($.data(this, moduleName + "-init")) return;
		$.data(this, moduleName + "-init", true);


		//
		// Валидация формы (обычное сообщение)
		//

		$(".jsFieldError").on("click", function() {

			$(this).parent().children(".jsFieldError").removeClass("field-error"),
			$(this).parent().children(".jsFieldErrorSub").hide();
		});



	});
};


/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/js/modules/formValidationInit.js
 **/